module.exports = __webpack_public_path__ + "img/presentation.abf2724a.png";